import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetShelfAndPartGeo = () => {
  const [loading, setLoading] = useState(true);
  const [shelfAndPartGeo, setShelfAndPartGeo] = useState([]);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getShelfAndPartGeo = ({ areaGuid } = {}) => {
    setLoading(true);

    axiosClient
      .get(`/Inventory/ProductData/GetShelfandPart?GUID=${areaGuid}`)
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          setShelfAndPartGeo(prev => {
            return res.data?.value;
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getShelfAndPartGeo, loading, shelfAndPartGeo, pageRef];
};

export default useGetShelfAndPartGeo;
